export default __webpack_public_path__ + "static/media/Roboto-BoldCondensed.01decb86.ttf";